import vue from 'vue';

export default function buildUserStore(store){
    store.actions.canAddLogin = async (context, params) => await vue.prototype.$myHttp.post('/api/users/canAddLogin', params);
    return store;
}